/**
 * Admin Routes Configuration
 * Routes are now centralized in config/CentralizedRoutes.js
 * This file imports routes from centralized configuration
 */
import { CENTRALIZED_ROUTE_MAP } from '../config/CentralizedRoutes';
import { Navigate } from 'react-router-dom';

// Redirect component for root admin path
const RedirectToAdminDashboard = () => <Navigate to="/admin/dashboard" replace />;

/**
 * Convert centralized route map to React Router route format for admin
 */
export const adminRoutes = [
  {
    path: '',
    element: RedirectToAdminDashboard
  },
  ...Object.entries(CENTRALIZED_ROUTE_MAP)
    .filter(([routePath]) => routePath.startsWith('/admin'))
    .map(([routePath, Component]) => {
      // Remove '/admin' prefix for React Router nested routes, preserving dynamic segments
      let path = routePath.replace('/admin', '') || 'dashboard';
      // Ensure dynamic routes like :id are preserved
      if (path.startsWith('/')) {
        path = path.substring(1);
      }
      
      // Handle redirects for unified pages with tabs
      if (routePath.includes('/settings/') && routePath !== '/admin/settings') {
        const tab = routePath.split('/').pop();
        return {
          path,
          element: () => <Navigate to={`/admin/settings?tab=${tab}`} replace />
        };
      }
      if (routePath.includes('/workflow/') && routePath !== '/admin/workflow') {
        const tab = routePath.split('/').pop();
        return {
          path,
          element: () => <Navigate to={`/admin/workflow?tab=${tab}`} replace />
        };
      }
      if (routePath.includes('/sla/') && routePath !== '/admin/sla') {
        const tab = routePath.split('/').pop();
        return {
          path,
          element: () => <Navigate to={`/admin/sla?tab=${tab}`} replace />
        };
      }
      if (routePath.includes('/notify/') && routePath !== '/admin/notify') {
        const tab = routePath.split('/').pop();
        return {
          path,
          element: () => <Navigate to={`/admin/notify?tab=${tab}`} replace />
        };
      }
      if (routePath.includes('/analytics/') && routePath !== '/admin/analytics') {
        const tab = routePath.split('/').pop();
        return {
          path,
          element: () => <Navigate to={`/admin/analytics?tab=${tab}`} replace />
        };
      }
      if (routePath.includes('/security/') && routePath !== '/admin/security') {
        const tab = routePath.split('/').pop();
        return {
          path,
          element: () => <Navigate to={`/admin/security?tab=${tab}`} replace />
        };
      }
      if (routePath.includes('/emails') && routePath !== '/admin/emails') {
        const tab = routePath.includes('template') ? 'templates' : 'diagnostics';
        return {
          path,
          element: () => <Navigate to={`/admin/emails?tab=${tab}`} replace />
        };
      }
      
      return {
        path,
        element: Component
      };
    })
];

export default adminRoutes;
